var _defs, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _polygon, _polygon2, _polygon3, _rect3, _rect4, _path7, _path8, _ellipse, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _polygon4, _rect5, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _g, _ellipse2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a531390e-bc5f-4010-9353-4bd32ed208ce",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "*, ::after, ::before { box-sizing: border-box; }\nimg, svg { vertical-align: middle; }\n"), /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "*, body, html { -webkit-font-smoothing: antialiased; }\nimg, svg { max-width: 100%; }\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.93,221.92C146,162.73,176,67.33,236.75,34.64c0,0,59.81-44.14,109.81,10.65,0,0,71.3,73.05,167.94,27.4,0,0,98.16-68.49,167.41,16.74,0,0,62.39,69.44,57.07,217.35,0,0,2.56,147.11-71.53,200.41,0,0-100,98.16-320.89,46,0,0-105.06-19.85-173-118.17-19.77-28.63-33.24-61.11-40.61-95.12q-.44-2-.87-4.05A271.25,271.25,0,0,1,132.93,221.92Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M739,306.78s2.13,122.59-53.86,184.5a112.93,112.93,0,0,1-17.66,15.91s-100,98.16-320.91,46c0,0-70.87-13.38-133.8-72.66a282.24,282.24,0,0,1-29.17-31.93q-5.12-6.53-10-13.58c-.12-.18-.24-.34-.37-.52-19.57-28.51-32.92-60.8-40.24-94.6-.29-1.33-.57-2.68-.86-4.05a270.92,270.92,0,0,1,.81-114C146,162.73,176,67.33,236.76,34.63c0,0,59.8-44.12,109.79,10.66,0,0,71.31,73.06,167.94,27.4,0,0,98.16-68.49,167.41,16.73C681.9,89.42,744.3,158.86,739,306.78Z",
    fill: "#fff",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M685.12,491.28a112.93,112.93,0,0,1-17.66,15.91s-100,98.16-320.91,46c0,0-70.87-13.38-133.8-72.66l396.1,3v7.68Z",
    fill: "#fff",
    opacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M324.89,442.26s37.86,47.26,52.87,50.69h19.3l40.38-58.36-22-20.25s-11.28-3.43-19.33-10.31l-27-23.32S357.11,431.53,324.89,442.26Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M437.44,434.59,397.06,493H377.75c-15-3.43-52.86-50.68-52.86-50.68C355.74,432,368.07,385,369.08,381l.06-.27,9.86,8.52v0L396.09,404c8.05,6.87,19.32,10.31,19.32,10.31Z",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M379,389.25,396.09,404c-2-7-4.38-14.29-7.09-21.85-3.3-9.24-6.79-17.85-10.31-25.83Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 197.01,
    y: 98.8,
    width: 218.06,
    height: 241.29,
    fill: "#e9e9e9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 206.6,
    y: 108.36,
    width: 199.43,
    height: 222.66,
    fill: "#f5f5f5"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "262.96 108.36 206.59 319.45 206.59 205.17 232.39 108.36 262.96 108.36",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "288.15 108.36 228.71 331.03 217.5 331.03 276.94 108.36 288.15 108.36",
    fill: "#fff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.02 169.08 406.02 283.38 393.4 331.03 362.83 331.03 406.02 169.08",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 302.17,
    y: 98.8,
    width: 7.74,
    height: 241.29,
    fill: "#e9e9e9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 200.79,
    y: 147.76,
    width: 210.08,
    height: 7.74,
    fill: "#e9e9e9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M529.15,442.27s-1.3,14-4.72,19.11c0,0,1.92-12.89-14.62-24.7,0,0-11.54-8-22.2-12.68a31.14,31.14,0,0,0-12.3-2.58c-4.75,0-11.37-.11-13.17-.31,0,0-29.65-1.29-46.4,29.95,0,0-9.34,9-12.57,7.1a30.88,30.88,0,0,0-1.46-6.74c-1.35-4.1-3.95-9.08-8.84-11.95,0,0-.33-4.51,12.56-7.41,0,0-2.89-9.34,10-17.71,0,0-13.22-4.2-19.34-10.31,0,0-12.57-37.7-17.39-47.69l.3,32.9s-19.64-16.31-30.67-24.08L350,306.78l.06-2.41s-3.86-7.76,21.11-20.25c0,0-6.52-7.61,3.94-7.61,0,0,10.07-3.43,16.88-8.1a10.29,10.29,0,0,0,3.8-12.36c-.13-.29-.27-.59-.42-.86,0,0,1.78-4,9,4.62l24.3,4.72L447.9,270s18.1,2.88,38.4,28l35.44,59.28S569.53,450.64,529.15,442.27Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M369.93,270.48l5.13,6a76.09,76.09,0,0,0,16.88-8.1s7-4.08,3.38-13.22l-10-19.38Z",
    fill: "#f7a48b"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 354.33,
    cy: 234.93,
    rx: 30.07,
    ry: 38.86,
    transform: "translate(-61.01 144.17) rotate(-21.22)",
    fill: "#f9b499"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M510.78,339l-22.67-37.89a45.52,45.52,0,0,0-5.12-7c-5.83-6.54-18.84-19.32-35.1-24.06l-19.26-5.49a224.39,224.39,0,0,1-2.9,46.08s-2.57,22.55.64,39.62c0,0,5.16,18,1.3,31.9,0,0-2.26-20.63-11.93-29,0,0-19.33-22.55-13.21-55.09a149.14,149.14,0,0,0,3.34-16.57h0a91.89,91.89,0,0,0,1-12.06v-.2c0-.66,0-1.32,0-2a14.29,14.29,0,0,0-4.57-9.89,8.86,8.86,0,0,0-.77-.66l0,0h0a.55.55,0,0,1-.1-.11c-2.51-1.95-5.19-3.41-6-1.38v0l-9.84-18-3.66-4.5s-6.54-8.84-13.05-4.69a23.48,23.48,0,0,1-8,3.46c-5,1-12.33,1.37-19.06-2.36a20.77,20.77,0,0,1-9-10.87,9.22,9.22,0,0,0-1.08-2A3.69,3.69,0,0,0,325,218.3c-.09,4.94.23,15.06,3.85,21.75a48.32,48.32,0,0,1,4.12,9.59A99.12,99.12,0,0,1,335.67,261s13.94,17.52,34.26,9.47l5.13,6s-10.13-.56-3.94,7.61c0,0-23.08,11-21.11,20.25l-1.68,60.8s-28.4-21.88-38.53-17.31c0,0-4.82-9.42,2.49-34.2,0,0,13-43.34,8.45-65,0,0-24.49-46.44,11-52.63,0,0,16.32-23.08,51.22-12.38,0,0,8.64,0,54.71,33.21l36.56,27.28a35.72,35.72,0,0,0,5.31,3.27c9.57,4.72,42.93,22.79,50.91,48.39C530.43,295.79,541.07,320.91,510.78,339Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M379,389.24l-9.86-8.52-.06.27-5.21-4.33s9.37-19,3.52-45.11a.69.69,0,0,1,1.21-.58c2.79,3.45,8,11.51,10.1,25.38Z",
    opacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M379,389.24v0L369.08,381l.06-.27Z",
    opacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M415.42,414.34s17.72-12.56,39.63-25.77c0,0-6.77-16.43-13.53-37.7,0,0-13.53-30.92-2.9-49,0,0-11,4.49-6.37,34.64a95,95,0,0,0,5.51,19.77c3.29,8.48,6.94,24.84-8.81,33.87,0,0-22.46,18.69-40.38-8.05l7.52,21.9S401.57,410.15,415.42,414.34Z",
    opacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M455.05,388.57a12.38,12.38,0,0,1,4.28-.68,15.17,15.17,0,0,1,4.33.63,12.81,12.81,0,0,1,3.95,2,10.2,10.2,0,0,1,2.9,3.24,28.15,28.15,0,0,0-3.52-2.25,20.66,20.66,0,0,0-3.76-1.51A38.63,38.63,0,0,0,455.05,388.57Z",
    opacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M481.16,422s20.6-4,16.41-30.94c0,0-9.66-47.92-20.29-70.47,0,0,23.52,39.63,27.7,79.9,0,0,1.57,19-5,29.95A80.5,80.5,0,0,0,481.16,422Z",
    opacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M507.56,426.91a48.39,48.39,0,0,1,12.32,5.59,34,34,0,0,1,5.41,4.16,13.91,13.91,0,0,1,3.86,5.6,20.15,20.15,0,0,0-4.64-4.71,60.43,60.43,0,0,0-5.43-3.78C515.33,431.39,511.44,429.23,507.56,426.91Z",
    opacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M429,366.73s-6.16-57.42,9.95-80.29c0,0,8.06-11,18.53-12.89,0,0-3.25-2.33-10.08-3.68l-18.76-5.34a299.41,299.41,0,0,1-2.9,46.07,132.59,132.59,0,0,0,.64,39.63S428.89,363.73,429,366.73Z",
    opacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M375.39,288.15s-21,5.49-25.44,18.63h0a24.47,24.47,0,0,0-.13-3.2c-.25-2.26,1-9.29,21.3-19.46Z",
    opacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M377.76,287.76a54,54,0,0,0,7.95-1.85,39.36,39.36,0,0,0,7.4-3.14,26.62,26.62,0,0,0,6.29-4.88l1.33-1.5c.41-.53.77-1.1,1.16-1.65l.59-.83.47-.9c.32-.61.64-1.21,1-1.81a19.26,19.26,0,0,1-3.65,7.46,22.39,22.39,0,0,1-6.44,5.42,30.07,30.07,0,0,1-7.83,3A28.81,28.81,0,0,1,377.76,287.76Z",
    opacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M462.14,421.11s44.94,12.17,12.55,70.17c0,0,32,.11,40.63-17.67l9.11-12.23S527,444.09,500,430.44c0,0-13-7.85-18.81-8.44C481.16,422,477.26,420.73,462.14,421.11Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M462.17,421.1s-27.38-3.15-46.43,30L364.58,565.77s10.3,12.66,25.61,10.3c0,0,55.89-68.89,56.65-87.44l27.85,2.65S509.21,436.82,462.17,421.1Z",
    fill: "#f9b499"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M446.84,488.63l2.24-10s33.54,3.24,37.23-23.85c0,0,1.34,14.13-11.62,36.51Z",
    fill: "#f7a48b"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M462.14,421.11s-29.65-1.29-46.4,29.95c0,0-9.34,9-12.57,7.1a30.88,30.88,0,0,0-1.46-6.74c.47-.21,9.36-4.22,8.5-12.25,0,0,4.45,7.94,10,0C420.24,439.17,436,415.72,462.14,421.11Z",
    opacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M394.61,465.87a4.82,4.82,0,0,0-1.56,3.46,2.63,2.63,0,0,1-.63,1.85c-2.84,2.93-14.3-6.69-14.3-6.69-9.71-8.84,14.75-25,14.75-25a24.21,24.21,0,0,1,10.3,18.69Z",
    fill: "#f9b499"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M394.61,465.87a4.82,4.82,0,0,0-1.56,3.46,2.63,2.63,0,0,1-.63,1.85c-3.38-4.62,3.05-10.25,5.46-12.12a3.48,3.48,0,0,0,1.3-2c1.23-5.93-4.74-15.26-6.05-17.23-.05-.07.05-.15.12-.1a24.23,24.23,0,0,1,9.92,18.42Z",
    fill: "#f7a48b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M334,423.75s-11.93,15-9.06,18.51a29.09,29.09,0,0,0,5.6-1.89,30.36,30.36,0,0,0,10.15-7.51Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M334,423.75s-11.93,15-9.06,18.51a29.09,29.09,0,0,0,5.6-1.89,30.36,30.36,0,0,0,10.15-7.51Z",
    opacity: 0.3
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M222.23,404.46s.21,24.22,17.12,26.64c0,0,51.39-20.19,74.16-35.23l27.13,37s18-13.29,28.49-52.15c0,0-39.18-33.54-56.15-33.51a8.43,8.43,0,0,0-4.56,1.39Z",
    fill: "#f9b499"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M313.51,395.87s12.35-8.27,16.86-17.61c0,0,2.73,59.6,18,36.08,0,0,14.24-23.82,15.54-37.68l5.26,4s-7.66,34.09-28.49,52.15Z",
    fill: "#f7a48b"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M239.36,431.1l-8.87,2.78-4.65,1.47-42.26,13.28q-5.12-6.53-10-13.58c-.12-.18-.24-.34-.37-.52l37.17-22.81,3.76-2.32,8.07-4.94C223.35,430.14,239.36,431.1,239.36,431.1Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M230.48,433.88l-4.64,1.47c-10.72-7.09-14.33-18.66-15.44-23.63l3.76-2.32C217.75,423.58,226.35,431,230.48,433.88Z",
    fill: "#fff",
    opacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M390.2,576.08l-4.84,7-3,4.35-15.8,23c2.79,14.72-22.69,31-22.69,31L330.36,658.6c-12.33,12.35-33.83,3.19-33.83,3.19-16.72-8.77,3.58-16.72,3.58-16.72a73.7,73.7,0,0,0,20.7-14.33c20.12-16,33.36-41,39.6-54.84.69-1.55,1.3-2.95,1.82-4.18,1.57-3.73,2.35-6,2.35-6S375.28,579,390.2,576.08Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M385.36,583.11l-3,4.35c-4.81-.81-14.6-3.43-22-11.56.69-1.55,1.3-2.95,1.82-4.18C364.28,574.81,370.17,581.08,385.36,583.11Z",
    fill: "#fff",
    opacity: 0.2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M333.61,193.79s44.8-15.67,73.66,25.65c0,0,17.81,20.92,21.36,45.09l23.76,6.67s16.35,5.2,33.91,26.84L510.78,339l6.92-4.78s-18.7-39.39-42.39-61.26a163.33,163.33,0,0,0-26.12-20.05s-26.73-17.92-41.62-38.27C407.57,214.59,370.52,166.62,333.61,193.79Z",
    opacity: 0.2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M406.83,269.2c-.18-6.73-3.13-10.43-4.6-11.86a8.86,8.86,0,0,0-.77-.66l-.06,0a.55.55,0,0,1-.1-.11c-5-4.48-5.87-1.8-6-1.38v0l-9.84-18-3.66-4.5s-6.54-8.84-13.05-4.69a23.48,23.48,0,0,1-8,3.46c-5,1-12.33,1.37-19.06-2.36a20.77,20.77,0,0,1-9-10.87,9.22,9.22,0,0,0-1.08-2A3.69,3.69,0,0,0,325,218.3s-2.6-18,8.65-4.59c0,0,10.72,21.73,33.71,12.07a18.69,18.69,0,0,0,4-2.33c4.32-3.2,17.77-11.65,26.3,0,0,0,19,33.35,8.21,58l1-12.06Z",
    opacity: 0.2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M387,239.93a6.35,6.35,0,0,0,6.94-4.12s8,13.36,10.38,24c0,0-7.52-9.56-9-4.62Z",
    opacity: 0.2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M348.33,357.82s-28.14-9.59-21.64-46.16c0,0,7.93-40.9,9-50.66,0,0,15.73,17.89,34.26,9.48l5.13,6s-9.37-1-3.94,7.61c0,0-24.74,10.19-21.17,22.66Z",
    opacity: 0.2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M348.75,270.48c.49-5.1-5.47,51.44.44,60.24l.76-23.94s-.74-13.62,21.17-22.66c0,0-5.68-7.81,3.94-7.61l-5.13-6S360.63,275,348.75,270.48Z",
    opacity: 0.2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M306,510.68H263.15V508.1l.42-8.8,1.8-39.54.28-6.22a3.49,3.49,0,0,1,3.67-3.11h30.26a3.55,3.55,0,0,1,3.7,3.11l.28,6.22,1.77,39.54.42,8.91Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "305.86 508.1 263.26 508.1 263.68 499.3 305.44 499.3 305.86 508.1",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M304.89,504.33H264.23a3.06,3.06,0,0,1-3.11-3v-.23l2.2-43a2.94,2.94,0,0,1,3.05-2.61h36.38a3,3,0,0,1,3,2.72l2.19,43a3.08,3.08,0,0,1-3.05,3.11Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a42788c4-886a-4bc2-8fb3-d6bcc3f4fefb",
    "data-name": "freepik--Plant--inject-606"
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M639.88,441.23c0-.54-1.83-54.22-10.52-62.7-8.45-8.21-18.17-.3-18.57,0l-1-1.16c.1-.09,11.15-9.11,20.56,0,9.16,8.91,11,61.5,11,63.74Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M640.63,451.78c0-.64-6-64.5,17.37-91.27l1.12,1c-22.89,26.29-17,89.5-17,90.13Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M639.91,445l-1.5-.1c0-.73,4.51-72.53-12.51-88.24l1-1.1C644.51,371.72,640.11,442,639.91,445Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M642.13,445h-1.5c0-2,.57-48.57,13.82-56.16a9.4,9.4,0,0,1,8.61-.84c8,3.32,12,17.57,12.17,18.18l-1.51.4c0-.15-4-14.16-11.29-17.2a8,8,0,0,0-7.29.77C642.65,397.28,642.13,444.5,642.13,445Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M637,445l-1.5-.08c0-.38,2-36.76-7.82-49.61-2.37-3.1-4.94-4.51-7.64-4.38-6.4.45-11.78,9.83-11.84,9.94l-1.31-.75c.24-.41,5.83-10.18,13-10.69,3.25-.21,6.24,1.5,8.93,5C639,407.7,637.07,443.5,637,445Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M639,450c-.27-3.54-6.44-86.71,4.42-101.38l1.2.89c-10.52,14.23-4.19,99.51-4.12,100.37Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M666,396.47s-6.5,2.39-4.51,8,22.48,15,22.48,15,8.61-7.9.7-20.72S666.16,392.41,666,396.47Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M637.73,385.7s6.93-.3,7.32,5.67-15,22.46-15,22.46-11-4-8.63-18.85S636,382,637.73,385.7Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M631.88,357.15s4.62-.49,4.24-3.3-17.94-10.05-28.29,1.65c0,0,6.63,11.4,16.22,11.55S631.88,357.15,631.88,357.15Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M640.48,350.33s-4.18,2-5.35-.57S645,331.71,660,336.22c0,0,.41,13.19-7.65,18.39S640.48,350.33,640.48,350.33Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M618.59,394.18s3.17-2.57-.26-3.82-20.29-.9-20.47,15.81c0,0,19.63,3.26,22.07-3.1S618.59,394.18,618.59,394.18Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M658.67,356.69s-3.18-2.57.26-3.84,20.3-.88,20.48,15.82c0,0-19.64,3.26-22.08-3.11S658.67,356.69,658.67,356.69Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M648.3,370.22s-.29-3.13,2.24-1.91S661.85,379,652.73,388c0,0-12.26-9-10-13.82S648.3,370.22,648.3,370.22Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M615.78,374.64s1.91-2.5-.89-2.81-15.27,3-12.36,15.5c0,0,15.22-1.14,15.87-6.32S615.78,374.64,615.78,374.64Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "667.2 491.28 614.98 491.28 609.34 434.1 672.84 434.1 667.2 491.28",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 606.56,
    y: 427.79,
    width: 69.07,
    height: 12.61,
    fill: "#2f2e41",
    "data-secondary": "true"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 606.56,
    y: 427.79,
    width: 69.07,
    height: 12.61,
    fill: "#fff",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "ac24b28a-c05e-4375-a961-6d71326adba3",
    "data-name": "freepik--Temperature--inject-606"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 572.11,
    cy: 236.38,
    r: 46.79,
    fill: "#0071f2",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    },
    "data-primary": "true"
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M572.1,283.82a47.42,47.42,0,1,1,47.42-47.42A47.42,47.42,0,0,1,572.1,283.82Zm0-93.59a46.17,46.17,0,1,0,46.18,46.17h0a46.23,46.23,0,0,0-46.18-46.17Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M572.1,265h-.33a12,12,0,0,1-11.53-11.86,11.85,11.85,0,0,1,5.17-9.78V214.48a6.69,6.69,0,0,1,13.38,0v28.86A11.85,11.85,0,0,1,572.1,265Zm0-56a5.43,5.43,0,0,0-5.42,5.44v29.23a.65.65,0,0,1-.3.52,10.59,10.59,0,1,0,11.45,0,.58.58,0,0,1-.28-.52V214.48A5.45,5.45,0,0,0,572.1,209Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M576.84,245.83l-1.16-.76V235h-7.09v10.1l-1.16.76a8.65,8.65,0,0,0-4,7.32,8.9,8.9,0,0,0,8.47,8.72h.22a8.72,8.72,0,0,0,4.71-16.06Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M560.23,215.37h-4.09a.61.61,0,0,1,.06-1.22h4.09a.63.63,0,0,1,.63.63h0a.62.62,0,0,1-.64.59Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M560.23,220.21h-4.09a.63.63,0,0,1-.72-.53.62.62,0,0,1,.52-.72.67.67,0,0,1,.2,0h4.09a.63.63,0,0,1,.72.53.64.64,0,0,1-.53.72Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M560.23,225.05h-4.09a.63.63,0,0,1-.2-1.25.67.67,0,0,1,.2,0h4.09a.63.63,0,1,1,.19,1.25Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M560.23,229.89h-4.09a.63.63,0,0,1-.63-.63h0a.61.61,0,0,1,.61-.62h4.11a.61.61,0,0,1,.63.6v0a.63.63,0,0,1-.63.63Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M560.23,234.73h-4.09a.63.63,0,0,1-.63-.63h0a.61.61,0,0,1,.61-.62h4.11a.61.61,0,0,1,.63.6v0a.63.63,0,0,1-.63.63Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M560.23,239.57h-4.09a.63.63,0,0,1-.63-.63h0a.61.61,0,0,1,.61-.62h4.11a.61.61,0,0,1,.63.6v0a.63.63,0,0,1-.63.63Z",
    fill: "#0071f2",
    "data-primary": "true"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ac59238a-08b6-495e-b622-54ffa99c4d52",
    "data-name": "freepik--Padlock--inject-606"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 638.89,
    cy: 150.8,
    r: 46.79,
    fill: "#0071f2",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    },
    "data-primary": "true"
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M638.89,198.21a47.42,47.42,0,1,1,47.42-47.41A47.42,47.42,0,0,1,638.89,198.21Zm0-93.57A46.17,46.17,0,1,0,685,150.83v0a46.22,46.22,0,0,0-46.15-46.09Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M650.72,145.31a1.27,1.27,0,0,1-1.26-1.27v-3.9a10.58,10.58,0,0,0-21.16,0V144a1.26,1.26,0,0,1-1.25,1.27,1.28,1.28,0,0,1-1.26-1.27v-3.9a13.1,13.1,0,1,1,26.18-.89c0,.29,0,.59,0,.89V144A1.27,1.27,0,0,1,650.72,145.31Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M652.61,147.1H625.14a3.14,3.14,0,0,0-3.14,3.14V170.1a3.16,3.16,0,0,0,3.14,3.14h27.47a3.13,3.13,0,0,0,3.14-3.14V150.24a3.12,3.12,0,0,0-3.11-3.14Zm-12.6,14V166h-2.18v-4.83a3.49,3.49,0,1,1,2.26,0Z",
    fill: "#0071f2",
    "data-primary": "true"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "b165e924-2a6f-4cf9-801b-e90a18e6a07b",
    "data-name": "freepik--Light--inject-606"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 497.64,
    cy: 148.61,
    r: 46.79,
    fill: "#0071f2",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    },
    "data-primary": "true"
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M497.64,196a47.42,47.42,0,1,1,47.42-47.42A47.42,47.42,0,0,1,497.64,196Zm0-93.59a46.18,46.18,0,1,0,46.17,46.17h0A46.25,46.25,0,0,0,497.64,102.44Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M506.33,164.54H489a.65.65,0,0,1-.59-.39l-1.2-3a16.76,16.76,0,1,1,21,0l-1.21,3A.63.63,0,0,1,506.33,164.54Zm-17-1.25h16.54l1-2.53a.58.58,0,0,1,.22-.42,15.54,15.54,0,1,0-21.81-2.77,15.84,15.84,0,0,0,2.78,2.77.58.58,0,0,1,.24.47Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M503.18,175.72H492.09a4.19,4.19,0,0,1-4.17-3.77l-.76-7.52a1,1,0,0,1,.89-1.11h19.06a1,1,0,0,1,1,1v.11l-.77,7.52A4.18,4.18,0,0,1,503.18,175.72Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M497.64,178.41c-3.09,0-5.51-1.59-5.51-3.64s2.42-3.65,5.51-3.65,5.5,1.6,5.5,3.65S500.72,178.41,497.64,178.41Zm0-6c-2.3,0-4.26,1.1-4.26,2.4s2,2.4,4.26,2.4,4.25-1.1,4.25-2.4-1.95-2.43-4.25-2.43Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M501.43,165.83h0a.64.64,0,0,1-.62-.65h0c0-.39.36-8.69,3.14-12.84h-2.51a.6.6,0,0,1-.6-.45l-.26-.87-1,3.29a.62.62,0,0,1-.59.44h0a.61.61,0,0,1-.58-.45l-.72-2.45-.73,2.45a.61.61,0,0,1-.58.45.63.63,0,0,1-.62-.44l-1-3.29-.26.87a.6.6,0,0,1-.6.45h-2.49c2.76,4.15,3.11,12.45,3.12,12.84a.62.62,0,0,1-.58.65h0a.65.65,0,0,1-.66-.6c0-.09-.4-9.86-3.61-13.07a.61.61,0,0,1-.13-.69.59.59,0,0,1,.57-.37h3.34l.69-2.44a.63.63,0,0,1,1.2,0l1,3.31.73-2.53a.65.65,0,0,1,.84-.36.63.63,0,0,1,.37.36L499,152l1-3.31a.7.7,0,0,1,.6-.44.63.63,0,0,1,.6.45l.71,2.44h3.33a.64.64,0,0,1,.58.38.62.62,0,0,1-.14.69c-3.22,3.22-3.62,13-3.62,13.06A.63.63,0,0,1,501.43,165.83Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M509.56,130.5a.76.76,0,0,1-.35-.11.65.65,0,0,1-.19-.87l3.73-5.86a.62.62,0,0,1,.87-.2.63.63,0,0,1,.19.87l-3.72,5.87A.68.68,0,0,1,509.56,130.5Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M517.77,139.82a.62.62,0,0,1-.28-1.18h0l6.28-3a.63.63,0,0,1,.84.3h0a.61.61,0,0,1-.29.82h0l-6.3,3A.51.51,0,0,1,517.77,139.82Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M526.58,152.94h-.08l-6.9-.88a.64.64,0,0,1-.6-.67.64.64,0,0,1,.67-.59h.1l6.88.89a.61.61,0,0,1,.54.7A.59.59,0,0,1,526.58,152.94Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M520.07,168a.61.61,0,0,1-.41-.15l-5.35-4.44a.63.63,0,0,1,.81-1l5.34,4.51a.64.64,0,0,1,.09.88A.66.66,0,0,1,520.07,168Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M485.71,130.5a.65.65,0,0,1-.52-.3l-3.73-5.87a.63.63,0,1,1,1.07-.67h0l3.73,5.86a.65.65,0,0,1-.2.87A.69.69,0,0,1,485.71,130.5Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M477.5,139.82a.53.53,0,0,1-.25,0l-6.3-3a.61.61,0,0,1-.3-.82.62.62,0,0,1,.83-.31l6.3,3a.62.62,0,0,1,.3.82h0A.61.61,0,0,1,477.5,139.82Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M468.69,152.94a.59.59,0,0,1-.61-.54.62.62,0,0,1,.54-.7l6.89-.89a.63.63,0,0,1,.16,1.25l-6.9.88Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M475.2,168a.71.71,0,0,1-.48-.23.64.64,0,0,1,.09-.88l5.34-4.51a.63.63,0,1,1,.81,1l-5.35,4.44A.59.59,0,0,1,475.2,168Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M497.64,127a.64.64,0,0,1-.64-.63h0v-6.94a.64.64,0,0,1,.63-.64.64.64,0,0,1,.64.63h0v6.94A.63.63,0,0,1,497.64,127Z",
    fill: "#0071f2",
    "data-primary": "true"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b6aa53b8-a6f8-4ce3-91c7-15201314d823",
    "data-name": "freepik--Sound--inject-606"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.3,440.62a.6.6,0,0,1-.58-.59v-5.82a.58.58,0,0,1,.58-.58.57.57,0,0,1,.58.58V440A.59.59,0,0,1,254.3,440.62Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.1,443.28a.58.58,0,0,1-.58-.58V431.5a.58.58,0,1,1,1.16,0v11.2A.58.58,0,0,1,257.1,443.28Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.9,439.85a.58.58,0,0,1-.58-.58v-4.33a.58.58,0,0,1,.58-.59.59.59,0,0,1,.59.59v4.33A.58.58,0,0,1,259.9,439.85Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.71,441a.58.58,0,0,1-.59-.58V433.8a.58.58,0,1,1,1.16,0v6.61A.58.58,0,0,1,262.71,441Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.5,443.29a.58.58,0,0,1-.58-.58v-11.2a.58.58,0,1,1,1.16,0v11.2A.58.58,0,0,1,265.5,443.29Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.31,440.18a.58.58,0,0,1-.58-.58v-5a.58.58,0,0,1,1.16,0v5A.58.58,0,0,1,268.31,440.18Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.1,438.6a.58.58,0,0,1-.58-.58V436.2a.59.59,0,0,1,1.17,0V438A.58.58,0,0,1,271.1,438.6Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.94,439.7a.58.58,0,0,1-.58-.58v-4a.58.58,0,0,1,1.16,0v4A.6.6,0,0,1,273.94,439.7Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.7,440.06a.58.58,0,0,1-.58-.58v-4.73a.58.58,0,1,1,1.16,0v4.73A.58.58,0,0,1,276.7,440.06Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.51,442.91a.58.58,0,0,1-.58-.59V431.91a.59.59,0,0,1,1.17,0V442.3a.6.6,0,0,1-.56.61Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.31,440.6a.58.58,0,0,1-.59-.58V434.2a.58.58,0,0,1,1.16,0V440A.58.58,0,0,1,282.31,440.6Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.11,438.81a.58.58,0,0,1-.58-.58v-2.17a.58.58,0,0,1,.59-.58.61.61,0,0,1,.58.58v2.17A.6.6,0,0,1,285.11,438.81Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.92,440a.58.58,0,0,1-.58-.58v-4.53a.58.58,0,0,1,.58-.59.6.6,0,0,1,.59.59v4.53A.58.58,0,0,1,287.92,440Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.71,438.92a.58.58,0,0,1-.58-.58v-2.42a.59.59,0,1,1,1.17,0v2.42A.58.58,0,0,1,290.71,438.92Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.51,438.5a.58.58,0,0,1-.58-.58v-1.58a.58.58,0,1,1,1.16,0v1.58A.58.58,0,0,1,293.51,438.5Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.31,441.45a.58.58,0,0,1-.58-.58v-7.48a.58.58,0,0,1,.58-.58.59.59,0,0,1,.58.58v7.48A.58.58,0,0,1,296.31,441.45Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.11,445.67a.58.58,0,0,1-.59-.58l0-15.91a.58.58,0,1,1,1.16,0v15.91A.58.58,0,0,1,299.11,445.67Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.89,440.48a.58.58,0,0,1-.58-.58v-5.52a.57.57,0,0,1,.58-.58.58.58,0,0,1,.58.58v5.52A.59.59,0,0,1,301.89,440.48Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.71,442.14a.59.59,0,0,1-.58-.59v-8.82a.58.58,0,1,1,1.16,0v8.82A.58.58,0,0,1,304.71,442.14Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.52,440.09a.58.58,0,0,1-.58-.58v-4.73a.58.58,0,0,1,.58-.58.57.57,0,0,1,.58.58v4.73A.58.58,0,0,1,307.52,440.09Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.31,443a.59.59,0,0,1-.58-.59V431.89a.58.58,0,0,1,1.16,0v10.48A.58.58,0,0,1,310.31,443Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.12,440.29a.58.58,0,0,1-.58-.58v-5.13a.58.58,0,0,1,.58-.58.61.61,0,0,1,.59.59v5.12A.59.59,0,0,1,313.12,440.29Z",
    fill: "#0071f2",
    "data-primary": "true"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 388.43,
    cy: 229.68,
    rx: 6.9,
    ry: 10.24,
    fill: "#f9b499"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.04283f1ee687fc573f89590fc1c465f6.svg";
export { ForwardRef as ReactComponent };